export enum LogSeverity {
  Unspecified = 0,
  Success,
  Info,
  Warning,
  Error,
  Critical,
}
